import * as BoxType from '@/services/rest-api/lib/delivery/box-type'

export const addressTypes = [
  { id: 'CITY', name: 'Kota' },
  { id: 'PROVINCE', name: 'Provinsi' },
]

export const rateDetailFields = [
  {
    name: 'box_type_id',
    label: 'Jenis Box',
    placeholder: 'Pilih Jenis Box',
    type: 'select-resourceful',
    validation: 'required',
    help: true,
    optionsGetter: BoxType.get,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj?.box_type,

    readOnlyKey: 'name',
  },
]

const addressFields = [
  {
    name: 'type',
    label: 'Tipe',
    placeholder: 'Pilih Tipe',

    type: 'select-resourceful',
    validation: 'required',
    help: true,
    optionsGetter: addressTypeGetter,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => addressTypes.find((type) => type.id === obj),

    readOnlyKey: 'name',
  },
  {
    name: 'name',
    label: 'Lokasi',
    placeholder: 'Pilih Lokasi',

    type: 'select-resourceful',
    validation: 'required',
    help: true,
    trackBy: 'name',
    optionsGetter: null,
    getInitialObject: (obj) => ({ name: obj }),
    optionLabelFn: ({ item }) => item.name,

    readOnlyKey: 'name',
  },
]

export const addressFieldsGroups = [
  {
    label: 'Lokasi Asal',
    name: 'origin',
    fields: addressFields,
  },
  {
    label: 'Lokasi Tujuan',
    name: 'destination',
    fields: addressFields,
  },
]

async function addressTypeGetter() {
  return {
    metadata: { total_page: 1, total_count: 2, page: 1 },
    data: {
      paginated_result: addressTypes,
    },
  }
}
